import { extendTailwindMerge } from 'tailwind-merge';

// Custom box-shadow utilities declared in src/styles.css (@theme inline, the
// part after `--shadow-`). tailwind-merge only knows the default shadow scale,
// so without registering these it will not dedupe them against other
// box-shadow utilities. Keep this list in sync with styles.css.
const customShadowScale = ['btn-primary', 'btn-secondary', 'inner-border-warm'];

export const twMergeConfig = {
  extend: {
    theme: {
      shadow: customShadowScale,
    },
  },
};

export const twMerge = extendTailwindMerge(twMergeConfig);
